module.exports = __webpack_public_path__ + "img/banerIndex.e356358e.png";